import React from 'react';
import { Select, MenuItem, FormControl } from '@mui/material';
import { FILTER_TYPE_OPTIONS } from '../../utils/filterTypes';

const FilterTypeDropdown = ({ value, onChange, disabled = false }) => {
  const labelFor = (val) =>
    FILTER_TYPE_OPTIONS.find((o) => o.value === val)?.label || val || '';

  return (
    <FormControl size="small" sx={{ minWidth: '12.5rem' }}>
      <Select
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        displayEmpty
        renderValue={(selected) =>
          selected ? labelFor(selected) : 'Select a filter type'
        }
        sx={{
          fontSize: '0.75rem',
          height: '2rem',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ddd',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#000',
          },
        }}
      >
        <MenuItem value="" sx={{ fontSize: '0.75rem' }}>
          Select a filter type
        </MenuItem>
        {FILTER_TYPE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value} sx={{ fontSize: '0.75rem' }}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FilterTypeDropdown;
